import { LoadState } from "../../constants/enums";



export interface IMPOIState {
  list: IMPOI[];
  loading: LoadState;
  mpoi: IMPOI;
  mpoiLoading: LoadState;
  error: string | null;
  reportList: IMPOIReport[];
  reportLoading: LoadState;
}

export interface IMPOI {
  request_uuid: string;
  customer_policy_id: number;
  customer_id: number;
  branch_code: string | null;
  branch_name: string | null;
  branch_address: {
    address_one: string | null;
    city: string | null;
    state_prov_cd: string | null;
    postal_code: string | null;
  };
  customer_name: string | null;
  customer_address: {
    address_one: string | null;
    address_two: string | null;
    city: string | null;
    state_prov_cd: string | null;
    postal_code: string | null;
  };
  customer_phone_number: string | null;
  customer_email_address: string[];
  policy_number: string | null;
  line_of_business: string | null;
  policy_effective_date: string | null;
  policy_expiry_date: string | null;
  insurer_code: string | null;
  insurance_company: string | null;
  insurance_company_address: {
    address: string | null;
    city: string | null;
    state_prov_cd: string | null;
    postal_code: string | null;
  };
  policy_status: string | null;
  vehicle: {
    key: string;
    make: string | null;
    model: string | null;
    year: number | null;
    vin: string | null;
    description: string | null;
    short_description: string | null;
  }[];
  extra_fields: {
    language_preferred: string | null;
    endorsement_date: string | null;
    vehicle_information_type: string | null;
  };
  email_salutations: string | null;
  email_customized_message: string | null;
}

export interface IMPOIReport {
  mpoi_reporting_data_id: number;
  request_uuid: string;
  customer_policy_id: number;
  customer_id: number;
  transaction_response_date: string;
  activity_date: string;
  message_status: {
    msgStatusCd: string;
    msgStatusDesc: string[];
  };
  transaction_seq_number: number;
  producer: {
    itemIdInfo: {
      otherIdentifier: {
        otherId: string;
        otherIdTypeCd: string[];
      }[];
    };
    generalPartyInfo: {
      nameInfo: {
        commlName: {
          commercialName: string;
        };
      };
    };
  };
  insured_or_principal: {
    generalPartyInfo: {
      nameInfo: {
        commlName: {
          commercialName: string;
        };
      };
      communications: {
        emailInfo: [
          {
            emailAddr: string;
          }
        ];
        languageCd: string;
      };
    };
  };
  partial_policy: {
    lobCd: string;
    companyCd: string;
    contractTerm: {
      effectiveDt: string;
      expirationDt: string;
    };
    policyNumber: string;
    generalPartyInfo: {
      nameInfo: {
        commlName: {
          commercialName: string;
        };
      };
    };
  };
  business_purpose_type_cd: string;
  include_eslip_print_copy_ind: string;
  pcveh: [
    {
      city: string | null;
      addr1: string | null;
      addr2: string | null;
      model: string | null;
      modelYear: string | null;
      postalCode: string | null;
      description: string | null;
      stateProvCd: string | null;
      businessName: string | null;
      manufacturer: string | null;
      shortDescription: string | null;
      vehIdentificationNumber: string | null;
    }
  ];
  card_type: string | null;
  file_attachment_info: string | null;
  created_by: string | null;
  owner_id: string | null;
  created_from_integration_api: number;
  comment: string | null;
  status: string;
}

export const initialMPOI: IMPOI = {
  customer_policy_id: 0,
  customer_id: 0,
  branch_name: "",
  branch_code: "",
  branch_address: {
    address_one: "",
    city: "",
    state_prov_cd: "",
    postal_code: "",
  },
  customer_name: "",
  customer_address: {
    address_one: "",
    address_two: "",
    city: "",
    state_prov_cd: "",
    postal_code: "",
  },
  customer_phone_number: "",
  customer_email_address: [],
  policy_number: "",
  line_of_business: "",
  extra_fields: {
    language_preferred: "E",
    endorsement_date: "",
    vehicle_information_type: "Auto",
  },
  policy_effective_date: "",
  policy_expiry_date: "",
  insurer_code: "",
  insurance_company: "",
  insurance_company_address: {
    address: "",
    city: "",
    state_prov_cd: "",
    postal_code: "",
  },
  policy_status: "csio:NBS",
  vehicle: [],
  request_uuid: "",
  email_salutations: "",
  email_customized_message: "",
};

export const initialMPOIState: IMPOIState = {
  list: [],
  loading: LoadState.NotLoaded,
  mpoi: initialMPOI,
  mpoiLoading: LoadState.NotLoaded,
  error: null,
  reportList: [],
  reportLoading: LoadState.NotLoaded,
};
